// 竞标：香港繁体中文字段。只维护显示文案，不改业务标识、数值或提交内容。

// 竞标页面
export const page = Object.freeze({
  "bidPage.filterConditions": "篩選條件",
  "bidPage.allBids": "全部競標",
  "bidPage.clear": "清空",
  "bidPage.filter": "篩選",
  "bidPage.allFilters": "全部篩選",
  "bidPage.closeFilters": "關閉篩選",
  "bidPage.productBrand": "產品品牌",
  "bidPage.goodsLocation": "貨所在地",
  "bidPage.goodsCondition": "貨物情況",
  "bidPage.allCategories": "全部產品分類",
  "bidPage.allBrands": "全部品牌",
  "bidPage.allLocations": "全部地區",
  "bidPage.allConditions": "全部情況",
  "bidPage.reset": "重置",
  "bidPage.done": "完成",
  "bidPage.statistics": "統計",
  "bidPage.manage": "管理",
  "bidPage.post": "發佈",
  "bidPage.bidding": "競標",
  "bidPage.bidStatistics": "截標統計",
  "bidPage.partNumbers": "截標料號",
  "bidPage.bidUsers": "競標用戶",
  "bidPage.table": "列表",
  "bidPage.loading": "載入中...",
  "bidPage.empty": "暫無相關供需資料",
  "bidPage.trend": "價格趨勢",
  "bidPage.trendFor": "{partNumber} 價格趨勢",
  "bidPage.currentPrice": "當前價格",
  "bidPage.lastPeriod": "較上期",
  "bidPage.recentHigh": "近期最高",
  "bidPage.recentLow": "近期最低",
  "bidPage.recentPeriods": "近6期價格走勢",
  "bidPage.periodLabel": "期數：{value}",
  "bidPage.publishedAt": "發佈時間",
  "bidPage.deadlineAt": "截標時間",
  "bidPage.openedAt": "開標時間",
  "bidPage.bidCount": "競標人數",
  "bidPage.currency": "貨幣",
  "bidPage.referenceUnitPrice": "參考單價",
  "bidPage.share": "分享",
  "bidPage.stock": "庫存",
  "bidPage.status": "狀態",
  "bidPage.id": "編號",
  "bidPage.unitPrice": "參考單價",
  "bidPage.wantBid": "我要競標",
  "bidPage.unknown": "未知",
  "bidPage.companyMissing": "未填寫公司",
  "bidPage.statisticsLoadFailed": "競標統計載入失敗，請稍後重試",
  "bidPage.listLoadFailed": "競標列表載入失敗，請稍後重試",
  "bidPage.referencePrice": "參考價格",
  "bidPage.statisticsEmpty": "暫無競標統計數據",
  "bidPage.brandPrefix": "品牌：",
  "bidPage.categoryPrefix": "產品分類：",
  "bidPage.technologyPrefix": "技術：",
  "bidPage.capacityPrefix": "容量：",
  "bidPage.locationPrefix": "貨所在地：",
  "bidPage.packagingPrefix": "包裝：",
  "bidPage.packagePrefix": "封裝：",
  "bidPage.periodPrefix": "期數：",
  "bidPage.idPrefix": "編號：",
  "bidPage.deadlinePrefix": "截標：",
  "bidPage.submittedForReview": "已提交審核",
  "bidPage.lowestQuote": "最低報價",
  "bidPage.totalBidQuantity": "競標總數量",
  "bidPage.selectPart": "全選本料號",
  "bidPage.select": "選擇",
  "bidPage.rank": "排名",
  "bidPage.lastBidAt": "最後競標時間",
  "bidPage.totalBidAmount": "競標總金額",
  "bidPage.selectedSummary": "所選競標彙總",
  "bidPage.selected": "已選",
  "bidPage.usersUnit": "位用戶",
  "bidPage.clearSelection": "清空選擇",
  "bidPage.totalQtyEditable": "總數量（可修改）",
  "bidPage.lowestEditable": "最低價（可修改）",
  "bidPage.selectedLowest": "選中最低競標價：",
  "bidPage.feeMode": "費用方式",
  "bidPage.external": "外收",
  "bidPage.feeRateEditable": "費用比例（可修改）",
  "bidPage.selectedAmount": "所選競標金額：",
  "bidPage.fee": "費用：",
  "bidPage.settlement": "結算金額：",
  "bidPage.updateReview": "更新審核數據",
  "bidPage.addReview": "加入審核彙總",
  "bidPage.confirmScope": "確認範圍",
  "bidPage.allPeriods": "全部期數（{count} 個）",
  "bidPage.periodCount": "{period}（{count} 個）",
  "bidPage.addedReview": "已加入審核彙總",
  "bidPage.partsUnit": "個料號，共涉及",
  "bidPage.periodsUnit": "個期數",
  "bidPage.partsAndPeriods": "{parts} 個料號，共涉及 {periods} 個期數",
  "bidPage.confirmAll": "確認全部",
  "bidPage.confirmPeriod": "確認本期",
  "bidPage.loadMore": "載入更多...",
  "bidPage.noMore": "沒有更多數據了",
  "bidPage.selectedRows": "已選擇 {count} 條",
  "bidPage.rowsUnit": "條",
  "bidPage.approve": "審核通過",
  "bidPage.statisticsLoadError": "競標統計載入失敗",
  "bidPage.listLoadError": "競標列表載入失敗",
  "bidPage.chooseReviewUsers": "請先選擇需要提交審核的競標用戶",
  "bidPage.invalidSettlement": "請填寫有效的總數量和最低價",
  "bidPage.reviewAddedNotice": "已加入審核彙總，請在頁面底部統一確認",
  "bidPage.invalidAuditNumber": "截標審核單號返回異常，請從競標審核列表查看",
  "bidPage.createAuditFailed": "生成截標審核單失敗，請重試",
  "bidPage.approveConfirm": "確定審核通過選中的 {count} 條資料嗎？",
  "bidPage.approveTitle": "審核確認",
  "bidPage.confirmApprove": "確定審核",
  "bidPage.cancel": "取消",
  "bidPage.approveSuccess": "已審核通過 {count} 條資料",
  "bidPage.deleteConfirm": "確定刪除選中的 {count} 條資料嗎？此操作不可恢復！",
  "bidPage.deleteTitle": "刪除確認",
  "bidPage.confirmDelete": "確定刪除",
  "bidPage.deleteFailed": "刪除失敗",
  "bidPage.deleteSuccess": "已刪除 {count} 條資料",
  "bidPage.specMissingFields": "當前競標缺少品牌或料號，無法匹配商品百科",
  "bidPage.specNotFound": "未找到對應商品百科",
  "bidPage.specLookupFailed": "查詢商品百科失敗，請稍後重試",
  "bidPage.noData": "暫無數據",
  "bidPage.copied": "已複製到剪切板",
  "bidPage.copyFailed": "複製失敗，請手動複製",
  "bidPage.unfavorited": "已取消收藏",
  "bidPage.favorited": "收藏成功，已同步到個人中心",
  "bidPage.loginToBid": "請先登入後再競標",
  "bidPage.loginToPost": "請先登入後再發布競標",
  "bidPage.closedCannotEdit": "當前競標已結束，不能修改報價",
  "bidPage.invalidQuote": "請輸入有效的報價",
  "bidPage.invalidQuantity": "請輸入有效的需求數量，不能超過庫存",
  "bidPage.submitFailed": "競價提交失敗",
  "bidPage.submitRetry": "競價提交失敗，請稍後重試",
  "bidPage.submitSuccess": "競價提交成功",
  "bidPage.shareCopied": "分享鏈接已複製到剪貼板",
  "bidPage.dayCountdown": "{days}天 {time}",
  "bidPage.locationHongKong": "中國香港",
  "bidPage.locationMainland": "中國大陸",
  "bidPage.locationBonded": "保税區",
  "bidPage.conditionOriginalFactory": "原廠",
  "bidPage.conditionOriginalBox": "原箱",
  "bidPage.conditionOriginalGoods": "原裝",
  "bidPage.conditionOriginalPack": "原包",
  "bidPage.conditionOriginalLabel": "原標",
  "bidPage.edit": "編輯",
  "bidPage.pendingPublish": "待發布",
  "bidPage.changeBid": "修改競標",
  "bidPage.awaitOpening": "待開標",
});

// 个人竞标
export const personal = Object.freeze({
  "biddingPersonal.followTitle": "我的跟單",
  "biddingPersonal.followerTitle": "我的跟單員",
  "biddingPersonal.followDescription": "查看被邀請人的競標參與狀態與開標結果",
  "biddingPersonal.followerDescription":
    "查看跟單員及關聯競標，可在截標前參與或修改競標資料",
  "biddingPersonal.searchFollow": "搜索型號/品牌",
  "biddingPersonal.searchFavorite": "搜索料號/品牌",
  "biddingPersonal.filterAll": "全部",
  "biddingPersonal.filterBidding": "競標中",
  "biddingPersonal.filterWaiting": "待開標",
  "biddingPersonal.filterOpened": "已開標",
  "biddingPersonal.stageInvited": "未參與競標",
  "biddingPersonal.stageBidding": "競標中",
  "biddingPersonal.stageWaiting": "等待開標",
  "biddingPersonal.stageWon": "已中標",
  "biddingPersonal.stageLost": "未中標",
  "biddingPersonal.exclusiveFollower": "專屬跟單員",
  "biddingPersonal.invitedPerson": "被邀請人",
  "biddingPersonal.follower": "跟單員",
  "biddingPersonal.submittedCount": "已提交 {count} 次",
  "biddingPersonal.establishedService": "已建立跟單服務關係",
  "biddingPersonal.relatedBid": "關聯競標 {model}",
  "biddingPersonal.viewFollower": "查看跟單員",
  "biddingPersonal.noFollowUsers": "暫無跟單用戶",
  "biddingPersonal.noFollowers": "暫無跟單員",
  "biddingPersonal.followUser": "跟單用戶",
  "biddingPersonal.bidModel": "競標型號",
  "biddingPersonal.currentStage": "當前階段",
  "biddingPersonal.submissionCount": "提交次數",
  "biddingPersonal.times": "{count} 次",
  "biddingPersonal.updatedAt": "狀態更新時間",
  "biddingPersonal.followUserDetail": "跟單用戶詳情",
  "biddingPersonal.followerDetail": "我的跟單員詳情",
  "biddingPersonal.myFollowUser": "我負責跟進的用戶",
  "biddingPersonal.myFollower": "為我服務的跟單員",
  "biddingPersonal.companyMissing": "未填寫公司",
  "biddingPersonal.relationshipAt": "建立關係於",
  "biddingPersonal.serving": "服務中",
  "biddingPersonal.bidFlow": "競標流程",
  "biddingPersonal.autoUpdated": "由競標狀態自動更新",
  "biddingPersonal.relationshipEstablished": "已建立關係",
  "biddingPersonal.participated": "參與競標",
  "biddingPersonal.waitingOpen": "等待開標",
  "biddingPersonal.relatedBidTitle": "關聯競標",
  "biddingPersonal.viewBid": "查看競標",
  "biddingPersonal.brandCategory": "品牌 / 分類",
  "biddingPersonal.requiredQuantity": "需求數量",
  "biddingPersonal.submissionRecords": "提交記錄",
  "biddingPersonal.deadline": "截標時間",
  "biddingPersonal.openAt": "開標時間",
  "biddingPersonal.bidActivity": "競標動態",
  "biddingPersonal.recentUpdate": "最近更新：{time}",
  "biddingPersonal.close": "關閉",
  "biddingPersonal.myFavorites": "我的收藏",
  "biddingPersonal.supply": "供應",
  "biddingPersonal.demand": "需求",
  "biddingPersonal.purchase": "求購",
  "biddingPersonal.unfavorite": "取消收藏",
  "biddingPersonal.category": "分類",
  "biddingPersonal.condition": "貨態",
  "biddingPersonal.favoriteAt": "收藏時間",
  "biddingPersonal.noFavorites": "暫無收藏的供需資料",
  "biddingPersonal.hintInvited": "已建立關係，尚未提交競標資料",
  "biddingPersonal.hintBidding": "截標前可以多次修改，以最後一次提交為準",
  "biddingPersonal.hintWaiting": "已截標，等待平台開標",
  "biddingPersonal.hintWon": "已開標，本次競標中標",
  "biddingPersonal.hintLost": "已開標，本次競標未中標",
  "biddingPersonal.hintDefault": "查看競標狀態",
  "biddingPersonal.openResult": "開標結果",
  "biddingPersonal.logRelation": "建立跟單關係",
  "biddingPersonal.logRelationDetail": "{name}通過競標分享邀請建立關係",
  "biddingPersonal.logSubmission": "提交競標資料",
  "biddingPersonal.logSubmissionDetail":
    "被邀請人已提交第 {count} 次競標資料，截標前仍可修改",
  "biddingPersonal.logWon": "本次競標已中標",
  "biddingPersonal.logLost": "本次競標未中標",
  "biddingPersonal.customer": "客戶",
});

export const messages = Object.freeze({ ...page, ...personal });
